// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3415 ? "c36f3faa" : chunkId) + "." + {"3415":"cf5e572d7c8c7fda","7883":"d7e2fd13f549358c"}[chunkId] + ".js";
};